import { Result } from "../../../models/Result";
import { httpService } from "../../HttpService";
import {
  MassPaymentUploadRequest,
  MassPaymentUploadResponse,
  FileStatusResponse,
  UploadResponse,
  MassPaymentProcessRequest,
  MassPaymentProcessResponse,
  GetCurrentProcessedTransactionsRequest,
  GetCurrentProcessedTransactionsResponse,
  DownloadFinalLogsRequest,
  DownloadFinalLogsResponse,
  TransactionsFinalLogsRequest,
  TransactionsFinalLogsResponse,
  ListMassPaymentFilesRequest,
  MassPaymentHistoryItem,
  DownloadProcessingErrorLogRequest,
  DownloadProcessingErrorLogResponse,
  GetFileProcessingErrorsRequest,
  GetFileProcessingErrorsResponse
} from "./types";

class MassPaymentApiService {
  path: string = "MassPayment";
  baseApiUrl = process.env.REACT_APP_ORCHESTRATOR_API_BASE_URL ?? process.env.REACT_APP_API_BASE_URL;

  uploadMassPaymentFile = async (request: MassPaymentUploadRequest): Promise<Result<MassPaymentUploadResponse>> => {
    return await httpService.post<MassPaymentUploadResponse>(`/${this.path}/upload-mass-payment-file`, request, { baseURL: this.baseApiUrl });
  };

  processTransactions = async (request: MassPaymentProcessRequest): Promise<Result<MassPaymentProcessResponse>> => {
    return await httpService.post<MassPaymentProcessResponse>(`/${this.path}/process-transactions?fileId=${request.fileId}&networkType=${request.networkType}`, {}, { baseURL: this.baseApiUrl });
  };

  getCurrentProcessedTransactions = async (request: GetCurrentProcessedTransactionsRequest): Promise<Result<GetCurrentProcessedTransactionsResponse>> => {
    return await httpService.post<GetCurrentProcessedTransactionsResponse>(`/${this.path}/current-processed-transactions`, request, { baseURL: this.baseApiUrl });
  };

  downloadFinalLogs = async (request: DownloadFinalLogsRequest): Promise<Result<DownloadFinalLogsResponse>> => {
    return await httpService.post<DownloadFinalLogsResponse>(`/${this.path}/download-final-logs`, request, { baseURL: this.baseApiUrl });
  };

  getTransactionsFinalLogs = async (request: TransactionsFinalLogsRequest): Promise<Result<TransactionsFinalLogsResponse>> => {
    return await httpService.post<TransactionsFinalLogsResponse>(`/${this.path}/transactions-final-logs`, request, { baseURL: this.baseApiUrl });
  };
  
  getFileStatus = async (fileId: number): Promise<Result<FileStatusResponse>> => {
    return await httpService.get<FileStatusResponse>(`/${this.path}/get-file-status/${fileId}`, { baseURL: this.baseApiUrl });
  };

  getUploadResponse = async (fileId: number): Promise<Result<UploadResponse>> => {
    return await httpService.get<UploadResponse>(`/${this.path}/get-upload-response/${fileId}`, { baseURL: this.baseApiUrl });
  };
  // History API Methods
  listMassPaymentFiles = async (request: ListMassPaymentFilesRequest): Promise<Result<MassPaymentHistoryItem[]>> => {
    return await httpService.post<MassPaymentHistoryItem[]>(`/${this.path}/${request.merchantId}/list-mass-payment-files`, {}, { baseURL: this.baseApiUrl });
  };

  downloadProcessingErrorLog = async (request: DownloadProcessingErrorLogRequest): Promise<Result<DownloadProcessingErrorLogResponse>> => {
    return await httpService.post<DownloadProcessingErrorLogResponse>(`/${this.path}/download-processing-error-log`, request, { baseURL: this.baseApiUrl });
  };

  getFileProcessingErrors = async (request: GetFileProcessingErrorsRequest): Promise<Result<GetFileProcessingErrorsResponse>> => {
    return await httpService.post<GetFileProcessingErrorsResponse>(`/${this.path}/get-file-processing-errors`, request, { baseURL: this.baseApiUrl });
  };
}

export const massPaymentApiService = new MassPaymentApiService();